import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DateTime } from 'luxon';
import DataSource from 'devextreme/data/data_source';
import { environment } from '../../services/app-settings.service';
import { DataCoreService } from '../../services/data-core.service';

@Injectable({
  providedIn: 'root',
})
export class DkTakvimService {
  constructor(
    private http: HttpClient,
    private dataCoreService: DataCoreService
  ) {}

  getSchedulerTasks(): Observable<any[]> {
    const tasks = Array.from({ length: 10 }, (_, i) => ({
      id: i + 1,
      text: `Görev ${i + 1}`,
      calendarId: (i % 3) + 1,
      startDate: DateTime.now().plus({ days: i }).toJSDate(),
      endDate: DateTime.now().plus({ days: i, hours: 2 }).toJSDate(),
      description: `Task açıklaması ${i + 1}`,
    }));
    return of(tasks);
  }


    getEtsSalon(): Observable<any> {
    const formData = new FormData();
    formData.append('lookupAd', 'ETS_SALON');
    return this.http.post(
      `${environment.lookupService}api/GetLookup_Request?jsconfig=eccn%2Cedv`,
      formData
    );
  }

  getMemurAd(): Observable<any> {
    const formData = new FormData();
    formData.append('lookupAd', 'ETS_MEMUR_AD');
    return this.http.post(
      `${environment.lookupService}api/GetLookup_Request?jsconfig=eccn%2Cedv`,
      formData
    );
  }


  /**
   * DKM-5069 Clara: ETS_MEMUR_AD lookup'ı pasif memurları da getirir (takvimdeki eski randevularda ad görünsün diye öyle kalır);
   * seçim listesini süzmek için aktif (AKTIF_EH='E') memur kodları. Okunamazsa null → süzülmez (sunucu kuralı yine engeller).
   */
  getAktifMemurKodlari(): Promise<Set<number> | null> {
    const ds = this.dataCoreService.getOData('EtsMemur', null, undefined, 'Kod', undefined, false);
    ds.filter(['AktifEh', '=', 'E']);
    return Promise.resolve(ds.load())
      .then((rows: any[]) => new Set<number>((rows ?? []).map((r: any) => Number(r?.Kod))))
      .catch(() => null);
  }

  createDataSource(data: any[]): DataSource {
    return new DataSource(data);
  }

  getEtsSalonDetayData() {
    const dataSource = this.dataCoreService.getOData('EtsSalonDetay');
    return dataSource;
  }

getEtsSalonDetayFilter(filter: any): DataSource {
  const dataSource = this.dataCoreService.getOData('EtsSalonDetay');

  const formatDate = (d: Date) =>
    `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2,'0')}-${(d.getDate() + 1).toString().padStart(2,'0')}T00:00:00`;

  dataSource.filter([
    ['RezervTarih', '>=', formatDate(filter.startDate)],
    'and',
    ['RezervTarih', '<=', formatDate(filter.endDate)]
  ]);

  dataSource.pageSize(1000);

  return dataSource;
}

}
